@if (
  dataType !== 'LicenseeCredential' &&
  dataType !== 'MemberCredential' &&
  dataType !== 'ActiveCertification'
) {
  @if (dataType === 'LongAnswer') {
    <div [innerHtml]="asString(value) | safeHtml"></div>
  } @else {
    @if (dataType === 'Complex') {
      <complex-field-snapshot
        [subFields]="asComplexSubFields(value)"
        [showAllFields]="showAllFields"
      ></complex-field-snapshot>
    } @else {
      @if (dataType === 'Skill') {
        <skill [selectedSkillLevel]="asSkillOrStar(value)"></skill>
      } @else {
        @if (dataType === 'StarRating') {
          <app-star-rating-attribute
            [selectedStarRating]="asSkillOrStar(value)"
          ></app-star-rating-attribute>
        } @else {
          {{ asString(value) | fieldDisplay: dataType
          }}<ng-content></ng-content>
        }
      }
    }
  }
} @else {
  @if (dataType === 'MemberCredential' || dataType === 'LicenseeCredential') {
    <credential-snapshot
      [credential]="asCredential(value)"
      [showName]="false"
    ></credential-snapshot>
  } @else {
    <certification-snapshot
      [certification]="asCertification(value)"
    ></certification-snapshot>
  }
}
